<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        block
        class="white--text"
        v-on="on"
      >
        Assign New Backup
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Backup Approver"
      text="Create Backup Approver"
      class="mb-0"
    > 
      <v-container v-if="dialog">
        <v-row no-gutters>
          <v-col
            cols="12"
            class="py-0"
          >
            <v-autocomplete
              v-model="delegator"
              v-validate="'required'"
              :error-messages="errors.collect('delegator')"
              data-vv-name="delegator"  
              data-vv-as="delegator"  
              :items="employees"
              label="Delegator"
              item-text="person.name"
              item-value="employee_uid"
              @input="getBackup()"
            />
          </v-col>
          <v-col
            cols="12"
            class="py-0"
          >
            <v-autocomplete
              v-model="backup"
              v-validate="'required'"
              :error-messages="errors.collect('backup')"
              data-vv-name="backup"  
              data-vv-as="backup"  
              :items="backups"
              :disabled="!delegator"
              :loading="loading"
              label="Backup"
              item-text="person.name"
              item-value="employee_uid"
            />
          </v-col>
          <v-col
            cols="12"
            class="py-0"
          >
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDate"
                  v-validate="'required'"
                  label="Start Date"
                  :error-messages="errors.collect('startDate')"
                  data-vv-name="startDate"  
                  data-vv-as="start date"    
                  readonly
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                no-title
                :min="today"
                :max="endDate"
                @input="startDateMenu = false"
              />
            </v-menu>
          </v-col>
          
          <v-col
            cols="12"
            class="py-0"
          >
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDate"
                  v-validate="'required'"
                  :disabled="!startDate"
                  label="End Date"
                  :error-messages="errors.collect('endDate')"
                  data-vv-name="endDate"  
                  data-vv-as="end date"    
                  readonly
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                :disabled="!startDate"
                no-title
                :min="startDate ? startDate : today"
                @input="endDateMenu = false"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            class="py-0"
          >
            <v-textarea
              v-model="reason"
              v-validate="'required|max:5000'"
              :rows="2"
              :error-messages="errors.collect('reason')"
              data-vv-name="reason"        
              label="Reason"
            />
          </v-col>
        </v-row>
        
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            class="px-10"
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            :loading="progressing"
            color="hrissecondary"   
            class="white--text px-10"       
            @click="submitForm"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employees: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,        
        loading: false,
        progressing: false,
        startDateMenu: false,
        startDate: null,
        endDateMenu: false,
        endDate: null,
        today: new Date().toISOString().slice(0, 10), 
        delegator: null,
        backup: null,
        reason: null,
        backups: [],
      }
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData()
        }
      },
    },
    methods: {
      getBackup () {
        this.loading = true

        this.$api.backupApprovers().listBackup(this.delegator)
          .then((res) => {
            this.backups = _.orderBy(res.data, ['person.name'], ['asc'])
            this.loading = false
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.backupApprovers().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  this.$emit('created')              
                  this.$snack({ message: 'Added new backup approver' })
                  this.$resetData()
                  this.dialog = false                 
                }
              })
              .catch(error => {
                if (error.response.data.message) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.message, 
                  })
                } else {
                  this.$snack({
                    color: 'error',
                    message: 'Failed to create new backup approver',
                  })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          employee_uid: this.backup,
          delegator_uid: this.delegator,
          start_date: this.startDate,
          end_date: this.endDate,
          reason: this.reason,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
